import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";
import { ButtonToolbar, Tabs } from "components/bootstrap";
import { CELL_PADDING_HORIZONTAL, CELL_PADDING_VERTICAL } from "components/common/EntityDataTable/Constants";
import { scrollContainerWidthVar } from "components/common/EntityDataTable/CSSVariables";
import ExpandedEntitiesSectionsContext from "./contexts/ExpandedSectionsContext";
import getAvailableSectionNames from "./getAvailableSectionNames";
const Container = styled.tr(
  ({ theme }) => css`
    &&&& {
      background-color: ${theme.colors.global.contentBackground};
    }
  `
);
const ContentCell = styled.td`
  && {
    padding: 0;
    border-top-color: ${({ theme }) => theme.colors.table.row.backgroundStriped} !important;
  }
`;
const Content = styled.div(
  ({ theme }) => css`
    position: sticky;
    left: 0;
    width: 100%;
    max-width: var(${scrollContainerWidthVar}, 100%);
    padding: ${CELL_PADDING_VERTICAL}px ${CELL_PADDING_HORIZONTAL}px ${theme.spacings.md} ${theme.spacings.lg};
    background-color: ${theme.colors.table.row.backgroundStriped};
  `
);
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    /* Moves the actions below the tabs, instead of squeezing both, when they don't fit next to each other. */
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: ${theme.spacings.sm};
    margin-bottom: ${theme.spacings.sm};
  `
);
const Actions = styled(ButtonToolbar)`
  display: flex;
  align-items: center;
`;
const SectionPanel = styled(Tabs.Panel)`
  padding: 0;
`;
const ExpandedSections = ({
  expandedSectionRenderers,
  entity,
  visibleCellCount
}) => {
  var _a, _b;
  const { expandedSections, toggleSection } = useContext(ExpandedEntitiesSectionsContext);
  const activeSectionName = (_a = expandedSections == null ? void 0 : expandedSections[entity.id]) == null ? void 0 : _a[0];
  const activeSection = activeSectionName ? expandedSectionRenderers == null ? void 0 : expandedSectionRenderers[activeSectionName] : void 0;
  if (!activeSection) {
    return null;
  }
  const sectionNames = getAvailableSectionNames(expandedSectionRenderers, entity);
  const hasMultipleSections = sectionNames.length > 1;
  const actions = (_b = activeSection.actions) == null ? void 0 : _b.call(activeSection, entity);
  const actionsToolbar = actions && /* @__PURE__ */ React.createElement(Actions, null, actions);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ContentCell, { colSpan: visibleCellCount }, /* @__PURE__ */ React.createElement(Content, null, hasMultipleSections ? (
    // Inactive sections stay unmounted, so they don't fetch their data in the background.
    /* @__PURE__ */ React.createElement(
      Tabs,
      {
        keepMounted: false,
        value: activeSectionName,
        onChange: (sectionName) => {
          if (sectionName && sectionName !== activeSectionName) {
            toggleSection(entity.id, sectionName);
          }
        }
      },
      /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Tabs.List, null, sectionNames.map((sectionName) => /* @__PURE__ */ React.createElement(Tabs.Tab, { key: sectionName, value: sectionName }, expandedSectionRenderers[sectionName].title))), actionsToolbar),
      sectionNames.map((sectionName) => /* @__PURE__ */ React.createElement(SectionPanel, { key: sectionName, value: sectionName }, expandedSectionRenderers[sectionName].content(entity)))
    )
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, activeSection.disableHeader !== true && /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("h3", null, activeSection.title), actionsToolbar), activeSection.content(entity)))));
};
export default ExpandedSections;
